import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "icon-clipboard" }, null, -1)
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.itemId)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "is-clickable",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyId && _ctx.copyId(...args))),
        title: "Copy this ID to your clipboard"
      }, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        _createElementVNode("samp", null, _toDisplayString(_ctx.displayedId), 1),
        _hoisted_1
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.displayedId), 1))
}